import {
    Component,
    EventEmitter,
    Input,
    Output,
    SimpleChanges,
} from '@angular/core';
import { Question } from '../../../models/QuestionResponse';

@Component({
    selector: 'q-gonogo',
    standalone: true,
    imports: [],
    templateUrl: './gonogo.component.html',
    styleUrl: './gonogo.component.scss',
})
export class GonogoComponent {
    @Input() question!: Question;
    @Input() pickedAnswers!: string[];
    @Input() validate!: () => void;
    @Output() pickedAnswersChange = new EventEmitter<string[]>();

    index: number = 0;
    showProposition = false;
    goButtonState: 'normal' | 'correct' | 'incorrect' = 'normal';
    noGoButtonState: 'normal' | 'correct' | 'incorrect' = 'normal';

    ngOnInit() {
        // Show proposition after initial load
        setTimeout(() => {
            this.showProposition = true;
        }, 500);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['question']) {
            this.showProposition = false;
            // Show proposition after change
            setTimeout(() => {
                this.showProposition = true;
            }, 100);
        }
    }

    validateQuestion(enabled: boolean) {
        const isCorrect =
            (enabled ? '1' : '0') === this.question.good_answers[this.index];

        // Set button state for visual feedback
        if (enabled) {
            this.goButtonState = isCorrect ? 'correct' : 'incorrect';
        } else {
            this.noGoButtonState = isCorrect ? 'correct' : 'incorrect';
        }

        this.pickedAnswers[this.index] = enabled ? '1' : '0';
        this.pickedAnswersChange.emit(this.pickedAnswers);

        // Wait for animation to complete before moving to next question
        setTimeout(() => {
            this.index += 1;

            // Reset button states
            this.goButtonState = 'normal';
            this.noGoButtonState = 'normal';

            if (this.index === this.pickedAnswers.length) {
                this.index = 0;
                this.validate();
            } else {
                // Hide current proposition and show next one
                this.showProposition = false;
                setTimeout(() => {
                    this.showProposition = true;
                }, 100);
            }
        }, 1000);
    }
}
